import { useState, useEffect, useCallback } from 'react';
import { navLinks } from '@/mocks/homeMangaData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (anchor: string) => {
    setMobileOpen(false);
    const el = document.querySelector(anchor);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18 max-w-[1280px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector('#hero');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2 cursor-pointer flex-shrink-0"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-read-fill text-background-50 text-lg"></i>
            </span>
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}>
              咻咻漫画
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              首页
            </a>
            {navLinks.map((link) => (
              <a
                key={link.anchor}
                href={link.anchor}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.anchor); }}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled
                ? 'text-foreground-700 hover:bg-background-200'
                : 'text-background-50 hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer"
            >
              首页
            </a>
            {navLinks.map((link) => (
              <a
                key={link.anchor}
                href={link.anchor}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.anchor); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}